// Wreqr is included in the Marionette source file
import Backbone from 'backbone'
import 'backbone.marionette'

export default Backbone.Wreqr;
